module.exports = __webpack_public_path__ + "packs/media/images/Warum_MM_3-70a2ea879cc84401e9af84bdcdb7dce0.jpg";